import {useEffect, useState} from "react";

/**
 * Persistiert den "Gelöschte anzeigen"-Toggle pro Tabelle in localStorage.
 *
 * Bewusst NICHT in `useLocalStorageOptions` integriert: `options.filter` wird
 * 1:1 an Server-Filter gemappt, `includeDeleted` ist dagegen eine separate
 * Top-Level-Query-Variable. Das Trennen vermeidet Filter-Kollisionen und macht
 * den Toggle für jede Tabelle unabhängig steuerbar.
 *
 * LocalStorage-Key folgt dem Pattern `${tablesEnumKey}:showDeleted`, also z.B.
 * `OpenPaymentsList:showDeleted`. Default ist immer `false`, damit Buchhaltung
 * im Standardfall nur aktive Posten sieht.
 */
export const useShowDeletedToggle = (tablesEnumKey: string): [boolean, (value: boolean) => void] => {
    const storageKey = `${tablesEnumKey}:showDeleted`;

    const [showDeleted, setShowDeleted] = useState<boolean>(() => {
        const stored = localStorage.getItem(storageKey);
        if (stored === null) {
            return false;
        }
        try {
            return JSON.parse(stored) === true;
        } catch (e) {
            return false;
        }
    });

    useEffect(() => {
        localStorage.setItem(storageKey, JSON.stringify(showDeleted));
    }, [storageKey, showDeleted]);

    return [showDeleted, setShowDeleted];
};
